
import axios from 'axios';

// Configuración base de Axios
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://localhost:7000/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

// Interceptor para agregar el token a todas las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;

      if (!/\/auth\/(ping|logout|login)/i.test(config.url || '')) void pingSession();
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Presence failures must not be confused with JWT authentication failures.
api.interceptors.response.use(
  response => response,
  async error => {
    const authorization=error.config?.headers?.Authorization;
    if(error.response?.status===403 && error.response?.data?.code==='PASSWORD_CHANGE_REQUIRED'
      && authorization==='Bearer '+localStorage.getItem('token')) {
      localStorage.setItem('password_change_required','1');
      if(window.location.pathname!=='/cambio-password-obligatorio') window.location.href='/cambio-password-obligatorio';
    }
    if(error.response?.status===401 && authorization==='Bearer '+localStorage.getItem('token')){
      let mustSignOut=true;
      const isPing=/\/auth\/ping(?:[?#]|$)/i.test(error.config?.url||'');
      if(isPing && error.response?.data?.code!=='SESSION_CLOSED'){
        // Older servers use an untyped 401 when the presence row is missing.
        // Verify the signed token independently; never call the interceptor recursively.
        try {
          await axios.get('/auth/verify',{
            baseURL:error.config?.baseURL||api.defaults.baseURL,
            headers:{Authorization:authorization},withCredentials:true,timeout:10000
          });
          mustSignOut=false;
        }catch(verificationError){
          // Network/availability failures do not prove credentials are invalid.
          mustSignOut=verificationError.response?.status===401;
        }
      }
      // An older in-flight request must never remove a newer login.
      if(mustSignOut && authorization==='Bearer '+localStorage.getItem('token')){
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('ultimo_ping');
        window.location.href='/login';
      }
    }
    return Promise.reject(error);
  }
);

let heartbeatInFlight = false;
export async function pingSession() {
  if (heartbeatInFlight || document.visibilityState === 'hidden' || !localStorage.getItem('token')) return;
  const last = Number(localStorage.getItem('ultimo_ping') || 0);
  if (Date.now()-last < 60000) return;
  heartbeatInFlight = true;
  localStorage.setItem('ultimo_ping',String(Date.now()));
  try { await api.post('/auth/ping'); } catch { /* Authentication failures are handled separately from presence failures. */ }
  finally { heartbeatInFlight = false; }
}
export function startSessionHeartbeat() {
  const tick=()=>{void pingSession();};
  tick(); const timer=window.setInterval(tick,60000);
  document.addEventListener('visibilitychange',tick);
  return ()=>{window.clearInterval(timer);document.removeEventListener('visibilitychange',tick);};
}

// ===== SERVICIOS DE AUTENTICACIÓN =====

export const authService = {
  /**
   * Login - Conecta con tu backend
   */
  login: async (usuario, contrasena, deviceId) => {
    try {
      const response = await api.post('/Auth/login', {
        usuario,
        contrasena,
        deviceId
      });
      
      // Guardar token y datos del usuario
      if (response.data.success) {
        localStorage.setItem('token', response.data.token);
        localStorage.removeItem('ultimo_ping');
        localStorage.setItem('user', JSON.stringify(response.data.usuario));
        localStorage.setItem('password_change_required',response.data.requiereCambioPassword ? '1' : '0');
      }
      
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error de conexión' };
    }
  },

  /**
   * Logout
   */
logout: async () => {
  const token = localStorage.getItem('token');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('ultimo_ping');
  localStorage.removeItem('password_change_required');
  sessionStorage.removeItem('usoPopupVisto');
  sessionStorage.removeItem('usoOcultoHasta');
  window.dispatchEvent(new Event('integra:logout'));
  if (!token) return;
  try {
    await axios.post('/auth/logout', null, {
      baseURL: api.defaults.baseURL, withCredentials: true, timeout: 10000,
      headers: { Authorization: 'Bearer '+token }
    });
  } catch {}

},

  /**
   * Obtener usuario actual
   */
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  /**
   * Verificar si está autenticado
   */
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },
  // ← AGREGAR AQUÍ
isTokenExpired: () => {
  const token = localStorage.getItem('token');
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch { return true; }
},
};

// ===== AQUÍ AGREGARÁS MÁS SERVICIOS =====
// Por ejemplo: clientesService, facturacionService, etc.
// ===== BITACORA SERVICE =====
export const bitacoraService = {
  registrar: (accion, modulo, submodulo = null, detalle = null, referenciaId = null) => {
    // fire and forget — no await, no bloquea nada
    api.post('/bitacora/registrar', {
      accion, modulo, submodulo, detalle, referenciaId
    }).catch(() => {}); // silencioso, nunca rompe el flujo
  }
};



export default api;
